<template>
	<div class="purchase">
		<form @submit.prevent="search()">
			<ManagingSection :column-count="2">
				<ManagingBox title="브랜드명">
					<SelectInput
						ref="searchBrand"
						:select-list="nameTypeList"
						:default-select-value="nameType"
						:input-full="true"
						placeholder="브랜드명 또는 법인명을 입력하세요."
						@change="searchBrandChange"
					/>
				</ManagingBox>
				<ManagingBox title="날짜">
					<DateRange v-model="dateRange" type="date" />
				</ManagingBox>
				<ManagingBox title="상품명">
					<SelectInput
						ref="searchProduct"
						:select-list="productTypeList"
						:default-select-value="productType"
						:input-full="true"
						placeholder="상품명 또는 내역을 입력하세요."
						@change="searchProductChange"
					/>
				</ManagingBox>
				<ManagingBox title="영업 담당자">
					<input type="text" v-model="ledgerManager" />
				</ManagingBox>
				<ManagingBox title="세금 계산서">
					<RadioList
						v-model="isPublish"
						valueName="name"
						:radioList="publishTex"
					/>
				</ManagingBox>
				<ManagingBox title="입금 확인">
					<RadioList
						v-model="isDeposit"
						valueName="name"
						:radioList="depositStatus"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button
					type="button"
					class="btn-main"
					v-text="'검색조건 초기화'"
					@click="searchInit()"
				/>
			</div>
		</form>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<p class="section__info__left purchase__total">
					총 매출 : {{ totalPrice }}
				</p>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						@click="csvDown"
					>
						엑셀다운로드
					</button>
					<Selector
						v-model="order"
						:option-list="orderList"
						class="section__info__items"
						@input="search()"
					/>
				</div>
			</template>
			<table class="table-main list">
				<thead>
					<tr>
						<th>날짜</th>
						<th>영업 담당자</th>
						<th>상품 구분</th>
						<th>거래 유형</th>
						<th>법인명</th>
						<th>브랜드명</th>
						<th>내역</th>
						<th>단가</th>
						<th>매입 (vat포함)</th>
						<th>매출 (vat포함)</th>
						<th>세금계산서</th>
						<th>입금확인</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in purchaseList" :key="item.id">
						<td>{{ item.ledgerDate }}</td>
						<td>{{ item.managerName }}</td>
						<td>{{ item.productDivision }}</td>
						<td>{{ item.dealType }}</td>
						<td>
							<RouterLink
								:to="`/intranet/customer-modify/${item.customerManageV2Id}`"
								target="_blank"
								class="link"
							>
								{{ item.companyName || '-' }}
							</RouterLink>
						</td>
						<td>{{ item.brandTitle || '-' }}</td>
						<td>
							<RouterLink
								:to="`/intranet/purchase-modify/${item.id}`"
								class="purchase__title link"
								>{{ item.title }}
							</RouterLink>
						</td>
						<td>{{ item.unitPrice || '-' }}</td>
						<td>{{ item.purchase || '-' }}</td>
						<td>{{ item.revenue || '-' }}</td>
						<td style="width: 120px">
							<ToggleswitchBox
								@changingVal="onToggleTex(item.id)"
								:checkSts="item.isTaxBill"
								:checkObj="{ value: true, text: '발행완료' }"
								:unCheckObj="{ value: false, text: '발행전' }"
							/>
						</td>
						<td style="width: 120px">
							<ToggleswitchBox
								@changingVal="onToggleDeposit(item.id)"
								:checkSts="item.depositCheck"
								:checkObj="{ value: true, text: '입금완료' }"
								:unCheckObj="{ value: false, text: '입금전' }"
							/>
						</td>
						<td>
							<button
								class="btn red"
								@click="deleteItem(item.id)"
							>
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<PaginationBox
			class="purchase__pagination"
			slot="pagination"
			:total-item="totalItem"
			:limit="limit"
			:offset="offset"
			@to="search($event.offset)"
		/>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector';
	import DateRange from '@/components/DateRange';
	import SelectInput from '@/components/SelectInput';
	import PaginationBox from '@/components/PaginationBox';
	import ToggleswitchBox from '@/components/ToggleswitchBox';
	import Util from '@/util';

	export default {
		name: 'PurchaseLedger',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			Selector,
			DateRange,
			SelectInput,
			PaginationBox,
			ToggleswitchBox,
		},
		data() {
			return {
				paramsKey: [
					'brandTitle',
					'companyName',
					'productDivision',
					'title',
					'isTaxBill',
					'depositCheck',
					'limit',
					'order',
					'offset',
					'ledgerManager',
					'startDate',
					'endDate',
				],
				dateRange: { from: '', to: '' },
				nameTypeList: [
					{ value: 'brandTitle', name: '브랜드명' },
					{ value: 'companyName', name: '법인명' },
				],
				nameType: 'brandTitle',
				productTypeList: [
					{ value: 'title', name: '내역' },
					{ value: 'productDivision', name: '상품명' },
				],
				productType: 'title',
				publishTex: [
					{ id: null, name: '전체' },
					{ id: 1, name: '발행 완료' },
					{ id: 2, name: '발행 전' },
				],
				isPublish: null,
				depositStatus: [
					{ id: null, name: '전체' },
					{ id: 1, name: '입금 완료' },
					{ id: 2, name: '입금 전' },
				],
				isDeposit: null,
				orderList: [
					{ value: 1, name: '최근등록순' },
					{ value: 2, name: '거래날짜순' },
				],
				order: 1,
				totalItem: 0,
				offset: 0,
				limit: 50,
				totalPrice: 0,
				purchaseList: [],
				searchBrand: '',
				searchBrandData: '',
				searchProduct: '',
				searchProductData: '',
				ledgerManager: '',
			};
		},
		mounted() {
			this.setFilter();
			this.getList();
		},
		methods: {
			searchInit() {
				this.isPublish = null;
				this.isDeposit = null;
				this.ledgerManager = '';
				this.$refs.searchBrand.inputModel = '';
				this.$refs.searchProduct.inputModel = '';
				this.searchBrand = '';
				this.searchBrandData = '';
				this.searchProduct = '';
				this.searchProductData = '';
				this.dateRange = {
					from: '',
					to: '',
				};
			},
			search(offset = 0) {
				this.offset = offset;
				this.replaceQuery();
				this.getList();
			},
			setFilter() {
				const query = this.$route.query;
				this.paramsKey.forEach(key => {
					const value = query[key];
					if (value && ['limit', 'order', 'offset'].includes(key)) {
						this[key] = Number(value);
					} else if (
						value &&
						['brandTitle', 'companyName'].includes(key)
					) {
						this.searchBrandData = value;
						this.searchBrand = key;
						this.$refs.searchBrand.inputModel = value;
						this.$refs.searchBrand.selectModel = key;
					} else if (value && ['ledgerManager'].includes(key)) {
						this[key] = String(value);
					} else if (
						value &&
						['productDivision', 'title'].includes(key)
					) {
						this.searchProductData = value;
						this.searchProduct = key;
						this.$refs.searchProduct.inputModel = value;
						this.$refs.searchProduct.selectModel = key;
					} else if (value && ['isTaxBill'].includes(key)) {
						this.isPublish = value === 'Y' ? 1 : 2;
					} else if (value && ['depositCheck'].includes(key)) {
						this.isDeposit = value === 1 ? 1 : 2;
					} else if (
						value &&
						['startDate', 'endDate'].includes(key)
					) {
						this.dateRange[key === 'startDate' ? 'from' : 'to'] =
							value;
					}
				});
			},
			getParams() {
				const params = {
					limit: this.limit,
					offset: this.offset,
					order: this.order,
				};

				if (this.isPublish) {
					params.isTaxBill = this.isPublish === 1 ? 'Y' : 'N';
				} else {
					delete params.isTaxBill;
				}

				if (this.isDeposit) {
					params.depositCheck = this.isDeposit === 1 ? 1 : 0;
				} else {
					delete params.depositCheck;
				}

				if (this.ledgerManager) {
					params.ledgerManager = this.ledgerManager;
				} else {
					delete params.ledgerManager;
				}

				if (this.searchBrandData) {
					params[this.searchBrand] = this.searchBrandData;
				} else {
					delete params[this.searchBrand];
				}

				if (this.searchProduct) {
					params[this.searchProduct] = this.searchProductData;
				} else {
					delete params[this.searchProduct];
				}

				if (this.dateRange) {
					if (this.dateRange.from) {
						params.startDate = this.dateRange.from.replace(
							/-/g,
							''
						);
					} else {
						delete params.startDate;
					}

					if (this.dateRange.to) {
						params.endDate = this.dateRange.to.replace(/-/g, '');
					} else {
						delete params.endDate;
					}
				}

				return params;
			},
			async getList() {
				try {
					const params = this.getParams();

					const { data } = await this.$axiosAdmin2.get(
						'/api/ledgerPurchaseV2',
						{ params }
					);
					this.totalPrice = data.totalPrice?.toLocaleString();
					this.totalItem = data.totalCount;
					this.purchaseList = data.ledgerPurchaseV2Elements;
					this.purchaseList.forEach(item => {
						item.ledgerDate = item.ledgerDate?.replace(
							/(\d{4})(\d{2})(\d{2})/,
							'$1-$2-$3'
						);
						item.unitPrice = item.unitPrice?.toLocaleString();
						item.ledgerPrice = item.ledgerPrice?.toLocaleString();
						if (item.ledgerType === '1') {
							item.purchase = item.ledgerPrice;
						} else {
							item.revenue = item.ledgerPrice;
						}
						item.isTaxBill = item.isTaxBill === 'Y';
						item.depositCheck = item.depositCheck === 1;
					});
				} catch (err) {
					console.error(err);
				}
			},
			async onToggleTex(val) {
				try {
					await this.$axiosAdmin2.put(
						`/api/ledgerPurchaseV2/${val}/taxInvoice`
					);
					this.getList();
				} catch (err) {
					alert(
						'상태 정보 업데이트에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async onToggleDeposit(val) {
				try {
					await this.$axiosAdmin2.put(
						`/api/ledgerPurchaseV2/${val}/deposit`
					);
					this.getList();
				} catch (err) {
					alert(
						'상태 정보 업데이트에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			replaceQuery() {
				const query = this.paramsKey.reduce((acc, key) => {
					const value = this[key];
					if (['offset', 'order', 'limit'].includes(key)) {
						acc[key] = Number(value);
					} else if (
						this.searchBrandData &&
						['brandTitle', 'companyName'].includes(key)
					) {
						const key =
							this.searchBrand === 'brandTitle'
								? 'brandTitle'
								: 'companyName';
						const value = String(this.searchBrandData);
						acc[key] = value;
					} else if (value && ['ledgerManager'].includes(key)) {
						acc[key] = String(value);
					} else if (
						this.searchProductData &&
						['productDivision', 'title'].includes(key)
					) {
						const key =
							this.searchProduct === 'productDivision'
								? 'productDivision'
								: 'title';
						const value = String(this.searchProductData);
						acc[key] = value;
					} else if (this.isPublish && ['isTaxBill'].includes(key)) {
						acc[key] = this.isPublish === 1 ? 'Y' : 'N';
					} else if (
						this.isDeposit &&
						['depositCheck'].includes(key)
					) {
						acc[key] = this.isDeposit === 1 ? 1 : 0;
					} else if (
						this.dateRange &&
						['startDate', 'endDate'].includes(key)
					) {
						if (this.dateRange.from)
							acc.startDate = this.dateRange.from;
						if (this.dateRange.to) acc.endDate = this.dateRange.to;
					}
					return acc;
				}, {});
				this.$router.replace({ query }).catch(() => {});
			},
			searchBrandChange({ select, input }) {
				this.searchBrand = select;
				this.searchBrandData = input;
			},
			searchProductChange({ select, input }) {
				this.searchProduct = select;
				this.searchProductData = input;
			},
			async deleteItem(id) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(
						`/api/ledgerPurchaseV2/${id}`
					);
					this.getList();
				} catch (err) {
					console.error(err);
				}
			},
			async csvDown() {
				try {
					const clickCb = async (params, period) => {
						params.limit = params.size;
						const { data, config } = await this.$axiosAdmin2.get(
							'/api/ledgerPurchaseV2',
							{ params }
						);
						const rows = data.ledgerPurchaseV2Elements.map(item => [
							item.ledgerDate.replace(
								/(\d{4})(\d{2})(\d{2})/,
								'$1-$2-$3'
							),
							item.managerName,
							item.productDivision,
							item.dealType,
							item.companyName,
							item.brandTitle ?? '-',
							item.title,
							item.unitPrice?.toLocaleString() ?? '-',
							item.registrationNumber,
							item.ceoName,
							item.location,
							item.industry,
							item.item,
							item.email ?? '-',
							item.emailExtra ?? '-',
							item.ledgerType === '1'
								? item.ledgerPrice?.toLocaleString()
								: '-',
							item.ledgerType === '2'
								? item.ledgerPrice?.toLocaleString()
								: '-',
							item.isTaxBill === 'Y' ? '발행완료' : '발행전',
							item.depositCheck === 0 ? '입금전' : '입금완료',
						]);
						const title = `매입 매출 관리(${period.replace(/(\s*)/g, '')})_${Date.now()}`;
						Util.getCsv(
							[rows],
							[title],
							[
								[
									'날짜',
									'영업담당자',
									'상품구분',
									'거래유형',
									'법인명',
									'브랜드명',
									'내역',
									'단가',
									'사업자 등록번호',
									'대표자명',
									'사업자 소재지',
									'업태',
									'종목',
									'이메일1',
									'이메일2',
									'매입(vat포함)',
									'매출(vat포함)',
									'세금계산서',
									'입금확인',
								],
							],
							`글로우픽_${title}`,
							config.url
						);
					};
					this.$store.commit('modal/toggleModal', {
						id: 'ExcelDownList',
						params: {
							total: this.totalItem,
							type: 'csList',
							params: this.getParams(),
							clickCb,
						},
					});
				} catch (err) {
					console.error(err);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.purchase {
		&__pagination {
			margin-top: 30px;
		}

		&__total {
			font-size: 25px;
			font-weight: 700;
		}
	}
</style>
